import feesActions from './fees-actions';
import { getSyiSlice } from 'tradera/apps/syi/state/selectors/syi';
import { resetCharityAndShippingInfo } from 'tradera/apps/syi/state/actions/charity-actions';
import { PURE_BIN_CATEGORY_IDS, ITEM_TYPE } from '../constants';
import { selectIsFeatureEnabled } from 'tradera/state/environment/selectors';
import { setCustomEndTime } from '../reducers/item-duration';
import { selectMagicalSyiSettngEnabled } from 'tradera/apps/syi/state/selectors/draft-selectors';
import { selectIsPureBinSelected } from 'tradera/apps/syi/state/selectors/price-selectors';
import { setHasUsedAutoFill } from 'tradera/apps/syi/state/reducers/predictions-reducer';

function toIntOrNull(number) {
    var i = parseInt(number);
    if (isFinite(i)) {
        return i;
    }
    return null;
}

function isNullOrUndefined(val) {
    return val === null || val === undefined;
}

const setOpeningBid = (openingBid) => (dispatch) => {
    dispatch({
        type: 'SET_OPENING_BID',
        payload: toIntOrNull(openingBid)
    });
};

const setFixedPrice = (fixedPrice) => (dispatch) => {
    dispatch({
        type: 'SET_FIXED_PRICE',
        payload: toIntOrNull(fixedPrice)
    });
};

const setReservePrice = (reservePrice) => (dispatch) => {
    dispatch({
        type: 'SET_RESERVE_PRICE',
        payload: toIntOrNull(reservePrice)
    });
    dispatch(feesActions.updatePrices());
};

const setAuctionBinPrice = (auctionBinPrice) => (dispatch) => {
    dispatch({
        type: 'SET_AUCTION_BIN_PRICE',
        payload: toIntOrNull(auctionBinPrice)
    });
};

const setReservePriceVisibility = (visible) => (dispatch) => {
    dispatch({
        type: 'SET_RESERVE_PRICE_VISIBILITY',
        payload: visible
    });
    if (!visible) {
        dispatch(setReservePrice(null));
    }
};

const setCharityDonationVisibility = (visible) => (dispatch) => {
    dispatch({
        type: 'SET_CHARITY_DONATION_VISIBILITY',
        payload: visible
    });
    if (!visible) {
        dispatch(resetCharityAndShippingInfo());
    }
};

const setEditCharity = (editCharity) => (dispatch) => {
    dispatch({
        type: 'SET_EDIT_CHARITY',
        payload: editCharity
    });
};

const setIsPureBinSelected = (isPureBinSelected) => (dispatch, getState) => {
    dispatch({
        type: 'SET_IS_PURE_BIN_SELECTED',
        isPureBinSelected,
        isChangeItem: getSyiSlice(getState()).syi.isEditOfPublishedItem
    });
    if (isPureBinSelected) {
        dispatch(setOpeningBid(null));
        dispatch(setAuctionBinPrice(null));
        dispatch(setReservePrice(null));
        dispatch(setCustomEndTime(null));
    } else {
        dispatch(setFixedPrice(null));
    }
};

const setIsPureBinSelectedFromPrediction =
    (isPureBinSelected) => (dispatch, getState) => {
        const isPristine = !getSyiSlice(getState()).price.isDirty;
        if (!isPristine) return;

        const oldValue = selectIsPureBinSelected(getState());

        dispatch(setIsPureBinSelected(isPureBinSelected));

        if (oldValue !== isPureBinSelected) {
            dispatch(setHasUsedAutoFill(true));
        }
    };

const setSelectedItemType = (itemType) => (dispatch, getState) => {
    dispatch({
        type: 'SET_SELECTED_ITEM_TYPE',
        itemType,
        isChangeItem: getSyiSlice(getState()).syi.isEditOfPublishedItem
    });

    if (itemType === ITEM_TYPE.BIN) {
        dispatch(setOpeningBid(null));
        dispatch(setAuctionBinPrice(null));
        dispatch(setReservePrice(null));
        dispatch(setCustomEndTime(null));
    } else if (itemType === ITEM_TYPE.AUCTION) {
        dispatch(setFixedPrice(null));
    } else if (itemType === ITEM_TYPE.AUCTION_AND_BIN) {
        dispatch(setFixedPrice(null));
    }
};

const setVat = (vat) => (dispatch) => {
    dispatch({
        type: 'SET_VAT',
        payload: vat
    });
};

const setFromDraft =
    (openingBid, fixedPrice, reservePrice, charityId, vat, isChangeItem) =>
    (dispatch) => {
        const queryParams = new URLSearchParams(location.search);
        const queryParamCharityId = queryParams.get('charityId');
        const hasOpeningBid = !isNullOrUndefined(openingBid);
        const hasFixedPrice = !isNullOrUndefined(fixedPrice);
        const hasReservePrice = !isNullOrUndefined(reservePrice);
        const hasCharityId =
            !isNullOrUndefined(charityId) ||
            !isNullOrUndefined(queryParamCharityId);
        const isAuction = hasOpeningBid && !hasFixedPrice;
        const isAuctionBin = hasOpeningBid && hasFixedPrice;
        const isPureBin = !hasOpeningBid && hasFixedPrice;

        dispatch(setVat(vat));

        // TODO: fewer changes to the state makes the page load faster...
        if (isAuction) {
            dispatch(setOpeningBid(openingBid));
            dispatch(setReservePrice(reservePrice));
            dispatch(setAuctionBinPrice(null));
            dispatch(setFixedPrice(null));
            dispatch(setReservePriceVisibility(hasReservePrice));
            dispatch(setCharityDonationVisibility(hasCharityId));
            dispatch(setIsPureBinSelected(false));
            dispatch(setSelectedItemType(ITEM_TYPE.AUCTION));
        } else if (isAuctionBin) {
            dispatch(setOpeningBid(openingBid));
            dispatch(setReservePrice(reservePrice));
            dispatch(setAuctionBinPrice(fixedPrice));
            dispatch(setFixedPrice(null));
            dispatch(setReservePriceVisibility(hasReservePrice));
            dispatch(setCharityDonationVisibility(hasCharityId));
            dispatch(setIsPureBinSelected(false));
            dispatch(setSelectedItemType(ITEM_TYPE.AUCTION_AND_BIN));
        } else if (isPureBin) {
            dispatch(setOpeningBid(null));
            dispatch(setReservePrice(null));
            dispatch(setAuctionBinPrice(null));
            dispatch(setFixedPrice(fixedPrice));
            dispatch(setReservePriceVisibility(false));
            dispatch(setCharityDonationVisibility(false));
            dispatch(setIsPureBinSelected(true));
            dispatch(setSelectedItemType(ITEM_TYPE.BIN));
        } else {
            dispatch(setOpeningBid(null));
            dispatch(setReservePrice(null));
            dispatch(setAuctionBinPrice(null));
            dispatch(setFixedPrice(null));
            dispatch(setReservePriceVisibility(false));
            dispatch(setCharityDonationVisibility(hasCharityId));
            dispatch(setIsPureBinSelected(false));
        }

        dispatch({
            type: 'SET_RESERVE_PRICE_CAN_CHANGE_BUT_NOT_BE_REMOVED',
            payload: isChangeItem && hasReservePrice
        });
    };

const reset = () => (dispatch) => {
    dispatch({
        type: 'RESET_PRICES_AND_VAT'
    });
};

const rootCategoryHasBeenSelected = (categoryId) => (dispatch, getState) => {
    const isPureBinCategory = PURE_BIN_CATEGORY_IDS.includes(categoryId);
    const isSelectBinByCategoryEnabled = selectIsFeatureEnabled(
        'syi-select-bin-for-selected-categories'
    )(getState());
    const isMagicalSyiFeatureEnabled =
        selectIsFeatureEnabled('magical-syi')(getState());
    const isMagicalSyiSettingEnabled =
        selectMagicalSyiSettngEnabled(getState());
    const isAutoFillConditionAndListingTypeEnabled = selectIsFeatureEnabled(
        'auto-fill-condition-and-listing-type'
    )(getState());
    const isEditOfPublishedItem =
        getSyiSlice(getState()).syi.isEditOfPublishedItem;

    // We do not want to change the auction type if the user is editing a
    // published item, since that's not allowed anyway
    if (
        isSelectBinByCategoryEnabled &&
        !isEditOfPublishedItem &&
        !isMagicalSyiFeatureEnabled &&
        !isAutoFillConditionAndListingTypeEnabled &&
        !isMagicalSyiSettingEnabled
    ) {
        dispatch(setIsPureBinSelected(isPureBinCategory));
    }
};

export default {
    setOpeningBid,
    setFixedPrice,
    setReservePrice,
    setAuctionBinPrice,
    setReservePriceVisibility,
    setCharityDonationVisibility,
    setEditCharity,
    setIsPureBinSelected,
    setIsPureBinSelectedFromPrediction,
    setFromDraft,
    rootCategoryHasBeenSelected,
    setVat,
    reset,
    setSelectedItemType
};
